import { render, staticRenderFns } from "./CopyrightAssignmentTransferMessages.vue?vue&type=template&id=5d9813cf&scoped=true&"
import script from "./CopyrightAssignmentTransferMessages.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTransferMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9813cf",
  null
  
)

export default component.exports